import NiceModal from '@ebay/nice-modal-react';

import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import Button from 'components/field/Button';
import Authorization from 'components/global/Authorization';
import PageHeader from 'components/global/PageHeader';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import useMediaQuery from 'hooks/useMediaQuery';
import useModalRouter from 'hooks/useModalRouter';

import { ENUMS, ORDER_AUTOMATION } from 'services/consts';

import { Breakpoints } from 'utils/const.styles';
import { DYNAMICLISTS } from 'utils/constants';

import { faPlus, faRobot, faScaleBalanced } from '@fortawesome/pro-solid-svg-icons';

import OrderOtomationSortForm from './OrderOtomationSortForm';
import OrderOtomationTestForm from './OrderOtomationTestForm';

/**
 * @author @omerrkosar
 */

const OrderOtomationList = () => {
	const { showModal } = useModalRouter();
	const defaultSort = useMemo(() => [{ id: 'id', desc: true }], []);
	const isMobile = useMediaQuery(Breakpoints.mobile);

	const columns = useMemo(
		() => [
			{ Header: 'id', accessor: 'id', width: 60, filterType: FilterType.number, show: false },
			{ Header: 'order', accessor: 'priorityOrder', width: 60, filterType: FilterType.number },
			{ Header: 'ruleName', accessor: 'ruleName', width: 150, filterType: FilterType.string, showOnMobile: true },
			{
				Header: 'broadcast',
				accessor: 'broadcast',
				width: 100,
				renderCell: ListComponents.STATUS,
				filterType: FilterType.enumMulti,
				enumName: ENUMS.YES_NO
			},
			{
				Header: 'reassign',
				accessor: 'reassign',
				width: 100,
				renderCell: ListComponents.STATUS,
				filterType: FilterType.enumMulti,
				enumName: ENUMS.YES_NO
			},
			{
				Header: 'priorityMethod',
				accessor: 'priorityMethodType',
				width: 120,
				filterType: FilterType.enumMulti,
				enumName: ENUMS.ORDER_OTOMATION_PRIORITY_METHODS
			},
			{
				Header: 'status',
				accessor: 'status',
				width: 130,
				renderCell: ListComponents.STATUS,
				filterType: FilterType.enumMulti,
				enumName: ENUMS.FEASIBILITY_STATUS,
				showOnMobile: true
			}
		],
		[]
	);

	return (
		<div className="orderOtomationList">
			<PageHeader
				title={isMobile ? 'orderOtomation' : 'orderAssignmentOtomation'}
				className="orderOtomationListHeader"
				lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/border/order-otomation.json.gz"
				moduleName="order-management">
				<Button
					icon={faScaleBalanced}
					label={!isMobile && 'sortRules'}
					onClick={() => NiceModal.show(OrderOtomationSortForm)}
					variant="black"
				/>
				<Button
					icon={faRobot}
					label={!isMobile && 'otomationTest'}
					onClick={() => NiceModal.show(OrderOtomationTestForm)}
					variant="black"
				/>
				<Authorization path="/modal/order-otomation-form">
					<Button
						lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/addOrder-icon.json.gz"
						variant="blue"
						className="addButton"
						icon={faPlus}
						label={!isMobile && 'addOrderOtomation'}
						onClick={() => showModal('order-otomation-form')}
					/>
				</Authorization>
			</PageHeader>
			<DynamicList
				id={DYNAMICLISTS.ORDER_AUTOMATION}
				columns={columns}
				fetchUrl={ORDER_AUTOMATION.GET_ORDER_AUTOMATION_LIST}
				defaultSort={defaultSort}
				actionObjectType={ACTION_OBJECT_TYPES.OTHER}
			/>
		</div>
	);
};

export default OrderOtomationList;
